import React, { useMemo } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import config from "../../../config/config";
import { BiFootball } from "react-icons/bi";

export const GoalScoreCard = ({ data }) => {
    const { i18n } = useTranslation();

    const groupedData = useMemo(() => {
        return (data || []).reduce((acc, event) => {
            const league = event?.league || "Unknown League";
            if (!acc[league]) acc[league] = [];
            acc[league].push(event);
            return acc;
        }, {});
    }, [data]);

    return (
        <div className="space-y-4 p-2">
            {Object.entries(groupedData || {}).map(([league, matches], idx) => (
                <div key={league} className="bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl rounded-2xl shadow-lg border-2 border-crimson/30 overflow-hidden transition-all duration-300 hover:shadow-xl hover:border-crimson/50 ">
                    {/* League Header */}
                    <div className="bg-gradient-to-br from-crimson via-red-primary to-crimson px-4 py-3 flex justify-between items-center relative">
                        <span className="text-sm font-bold text-white drop-shadow-sm">
                            {league}
                        </span>
                        <span className="text-xs bg-golden/95 rounded-lg px-2.5 py-1 text-blue-primary font-bold border border-golden/60">{matches.length}</span>
                        {/* Luxury Border Accent at bottom */}
                        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-golden via-white to-golden"></div>
                    </div>

                    {/* Matches List */}
                    <div className="divide-y divide-crimson/20">
                        {matches.map((event, index) => {
                            const homeIsNE = event.homeGoal === "NE";
                            const awayIsNE = event.awayGoal === "NE";
                            const homeGoalNum = homeIsNE ? NaN : parseInt(event.homeGoal);
                            const awayGoalNum = awayIsNE ? NaN : parseInt(event.awayGoal);
                            const isFinished = event.status === "FT";
                            const homeBold = !isNaN(homeGoalNum) && !isNaN(awayGoalNum) && homeGoalNum > awayGoalNum;
                            const awayBold = !isNaN(homeGoalNum) && !isNaN(awayGoalNum) && awayGoalNum > homeGoalNum;

                            return (
                                <div key={`${league}-${event.eventId || index}`} className="flex items-center px-4 py-3 text-sm hover:bg-crimson/5 transition-colors duration-200">
                                    {/* Time & Status */}
                                    <div className="w-[68px] text-center">
                                        <div className="text-blue-primary font-bold text-xs">
                                            {moment(event.event).format("h:mm A")}
                                        </div>
                                        <div className="text-xs mt-1.5 text-blue-primary font-semibold">
                                            {config.goal_status[event.status]}
                                        </div>
                                    </div>

                                    {/* Teams & Scores */}
                                    <div className="flex flex-col flex-1 ml-3 px-2 gap-2 font-myanmarSansPro">
                                        <div className="flex justify-between items-center">
                                            <span className={`${homeBold ? "font-bold" : ""} text-blue-primary`}>
                                                {i18n.language === "en" ? event.homeTeam : event.homeTeamMyan}
                                            </span>
                                            <span className={`${homeBold ? "font-bold bg-crimson/10 px-2 py-0.5 rounded border border-crimson/30" : "bg-white/80 px-2 py-0.5 rounded border border-crimson/20"} text-blue-primary font-mono`}>
                                                {homeIsNE ? "-" : event.homeGoal}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className={`${awayBold ? "font-bold" : ""} text-blue-primary`}>
                                                {i18n.language === "en" ? event.awayTeam : event.awayTeamMyan}
                                            </span>
                                            <span className={`${awayBold ? "font-bold bg-crimson/10 px-2 py-0.5 rounded border border-crimson/30" : "bg-white/80 px-2 py-0.5 rounded border border-crimson/20"} text-blue-primary font-mono`}>
                                                {awayIsNE ? "-" : event.awayGoal}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};
